import { render } from "./g-text-html.vue?vue&type=template&id=63e9c780&ts=true"
import script from "./g-text-html.vue?vue&type=script&lang=tsx"
export * from "./g-text-html.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__